import cookies from 'js-cookie';

const APP_BANNER_COOKIE_NAME = 'ha-app-banner';
const COOKIE_EXPERIMENT_NAME = 'HA_NATIVE_ADOPTION_BANNER_DISMISS';
const GLOBAL_BANNER_COOKIE_PREFIX = 'ha-global-banner';

// Variant to Day Map defined in HAFF-2677
const testVariantToDaysMap = {
    // Control sets cookie expiry to 1 week
    0: 7,
    // Variant 1 should not set a cookie
    1: -1,
    // Variant 2 sets cookie expiry to 2 weeks
    2: 14
};

function createCookie(testVariant) {
    let days = testVariantToDaysMap[testVariant];
    cookies.set(APP_BANNER_COOKIE_NAME, testVariant, {expires: days});
}

function cookieExists(cookieName) {
    let cookieValue = cookies.get(cookieName);
    if (typeof cookieValue !== 'undefined') {
        return true;
    }
    return false;
}

export {
    APP_BANNER_COOKIE_NAME,
    COOKIE_EXPERIMENT_NAME,
    GLOBAL_BANNER_COOKIE_PREFIX,
    createCookie,
    cookieExists
};